export { default as AvailabilityText } from "./AvailabilityText";
